<template lang="html">
  <item-editor-dialog
    :id="selectedItemId"
    ref="editForm"
    v-model="selectedPanel"
    :show="showItem"
    :clone-id="cloneId"
    :title="pageTitle"
    :on-close="doClose"
    :context-menu="defaultContextMenu"
    :lock-timer="lockTimerSettings"
    :loading="isDataLoading"
    :errors="errors"
    :edit-panel-id="editPanel"
    :audit-panel-id="auditPanel"
    :audit="auditHistorySettings"
    :buttons="pageBarButtons"
  >
    <!-- START OF FORM FIELDS -->
    <v-flex class="pa-3">
      <v-text-field
        v-model.trim="itemData.name"
        :label="type + ' Name'"
        :rules="rules().required('Name')"
        :error-messages="getPathErrors(jsonPath, 'name')"
        :disabled="isFormDisabled"
        required
        @input="clearPathErrors(jsonPath, 'name')"
      />

      <v-autocomplete
        v-model="itemData.terminalGroupId"
        prepend-icon="mdi-lan"
        label="Group"
        :items="terminalGroups"
        :rules="rules().required()"
        required
        item-text="name"
        item-value="id"
        @input="clearPathErrors(jsonPath, 'terminalGroupId')"
      />

      <v-textarea
        v-model.trim="itemData.notes"
        label="Comments"
        :rows="1"
        auto-grow
        :error-messages="getPathErrors(jsonPath, 'notes')"
        :disabled="isFormDisabled"
        @input="clearPathErrors(jsonPath, 'notes')"
      />

      <v-boolean
        v-model="itemData.disabled"
        label="Enabled"
        invert
        :error-messages="getPathErrors(jsonPath, 'disabled')"
        :field-errors="getPathErrors(jsonPath, 'disabled')"
        :disabled="isFormDisabled"
      />
    </v-flex>
    <!-- END OF FORM FIELDS -->
  </item-editor-dialog>
</template>

<script>
import {itemEdit} from '@/ft-vue-core'

var itemDefault = {
  name: '',
  notes: '',
  disabled: false,
  appMode: null,
  id: null,
  recordLockExpiration: null
}

export default {
  name: 'TerminalItem',
  components: {
  },
  mixins: [itemEdit],
  data: function () {
    return {
      type: 'Terminal',
      types: 'Terminals',
      apiRecordCommand: 'terminal',
      itemDefault: itemDefault,
      terminalGroups: [],

    }
  },
  computed: {
  },
  methods: {
    itemResourceCommands () {
      return [
        {
          command: 'terminalGroup',
          load: this.terminalGroups,
          loading: this.isLoading,
          params: {filter_methods: {filterFieldValue: ['appMode', this.$ftAPI().appMode()]}}
        }
      ]
    },
    resetLocalValues (keepItemData) {
      this.itemDefault.appMode = this.$ftAPI().appMode()
    },
    afterSave (r) {
      const key = r && r[0] && r[0].key
      if (this.isNewItem && (!this.$ftAC.terminal || !this.$ftAC.terminal.id) && key) {
        console.warn('Registering Terminal', r)
        this.$ftAPI().setGlobalAppState({
          key: key,
          jwt: r[0].jwt
        })
        this.$ftAPI().requestClubSettingsRefresh()
      } else {
        console.warn('NOT Registering Terminal', this.isNewItem, !this.$ftAC.terminal || !this.$ftAC.terminal.id, key, this.$ftAC.terminal, this.$ftAC.terminal.id, r)
      }
    }
  }
}
</script>
